import React from 'react';
import { Helmet } from 'react-helmet';

/**
 * Enhanced SEO Component for managing page meta tags
 * Optimized for local SEO and "near me" searches
 * Use this component in each page to set custom SEO metadata
 */
const SEO = ({ 
  title = "Miracle Lighting | LED Lights, String Lights & Decorative Lighting Near You | Sri Lanka",
  description = "Looking for LED lights, string lights, lamp shades, ceiling lights, or wall lights near you? Miracle Lighting provides wedding, birthday, Christmas, Kathina, and Vesak decorative lighting across Sri Lanka. Quality light decorations and strips for all events.",
  keywords = "miracle lighting, miracle lighting Sri Lanka, මිරකල් ලයිටින් ශ්‍රී ලංකා, wedding lighting services Western Province, event lighting services Colombo, wedding lighting Sri Lanka, light decoration services Sri Lanka, event lighting near me Sri Lanka, lighting decoration Colombo, lighting decoration Western Province, best wedding lighting company Colombo, lighting for weddings Sri Lanka, party lighting services Western Province, wedding reception lighting Colombo, professional lighting services Sri Lanka, outdoor wedding lighting Sri Lanka, western province wedding lighting, වෙස්ටර්න් ප්‍රොවින්ස් විවාහ ලයිටින්, Colombo event lighting & decoration, කොළඹ උත්සව ලයිටින් සහ සැරසිලි, Gampaha lighting services, ගම්පහ ලයිටින් සේවා, Kalutara event lights & decoration, කළුතර උත්සව ලයිට් සහ සැරසිලි, lighting setup for weddings Sri Lanka, outdoor event lighting Sri Lanka, LED lighting decoration Sri Lanka, stage and party lighting Colombo, wedding lights setup Sri Lanka, custom lighting designs for weddings, corporate event lighting Sri Lanka, led lights near me, string lights near me, lamp shades near me, ceiling light near me, light decoration near me, light strips near me, wall light nearby, lights near me, miracle home, wedding lights, event lighting, decorative lights, Christmas lights, birthday party lights, Kathina festival, Vesak lighting, Colombo, Gampaha, Kandy, Negombo, Sri Lanka",
  image = "https://miraclelighting.lk/cover.jpg",
  url = "https://miraclelighting.lk",
  type = "website",
  author = "Miracle Lighting",
  locale = "en_LK",
  structuredData = null
}) => {
  return (
    <Helmet>
      {/* Basic SEO */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      
      {/* Geographic Targeting - Critical for "near me" searches */}
      <meta name="geo.region" content="LK" />
      <meta name="geo.placename" content="Sri Lanka" />
      <meta name="geo.position" content="7.8731;80.7718" />
      <meta name="ICBM" content="7.8731, 80.7718" />
      
      {/* Open Graph (Facebook, WhatsApp) */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:locale" content={locale} />
      <meta property="og:site_name" content="Miracle Lighting" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Additional Meta Tags */}
      <meta httpEquiv="content-language" content="en" />
      <meta name="language" content="English" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
      
      {/* Structured Data (JSON-LD) */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
